import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CluConfirmDialogComponent } from './clu-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CluConfirmDialogService {
    constructor( private dialog: MatDialog, private _translateService : TranslateService) {
    }

    showConfirmDialog(title: string, message: string, confirmText : string | undefined = undefined) {
        return new Promise<boolean>((resolve, reject) => {
            let CC_HEIGHT = window.innerHeight && window.innerHeight < 700 ? '100%' : '700px';
            const dialogRef = this.dialog.open(CluConfirmDialogComponent, {
                disableClose: true, width: '100%', maxWidth: '700px', minHeight: CC_HEIGHT, maxHeight: CC_HEIGHT, height : CC_HEIGHT,
                data: { title: title, message: message, confirmText: confirmText }
            });

            dialogRef.afterClosed().subscribe(dialogResult => {
                resolve(dialogResult);
            });
        });
    }

    showConfirmDialogTr(title: string, message: string, _trParams : any, confirmText : string | undefined = undefined) {
        return new Promise<boolean>((resolve, reject) => {
            let CC_HEIGHT = window.innerHeight && window.innerHeight < 700 ? '100%' : '700px';
            const trTitle = this._translateService.instant(title, _trParams);
            const trMessage = this._translateService.instant(message, _trParams);
            const dialogRef = this.dialog.open(CluConfirmDialogComponent, {
                disableClose: true, width: '100%', maxWidth: '700px', minHeight: CC_HEIGHT, maxHeight: CC_HEIGHT, height : CC_HEIGHT,
                data: { title: trTitle, message: trMessage, confirmText: confirmText }
            });
            
            dialogRef.afterClosed().subscribe(dialogResult => {
                resolve(dialogResult);
            });
        });
    }
}